export * from './new-intense.component';
